export enum DateCalendar {
    Islamic = 'ah',
    Gregorian = 'ad',
    All = 'all'
}

export interface DateRange {
    from: number;
    to: number;
    calendar?: DateCalendar;
}

export interface DateStruct {
    ah: DateRange; // islamic calendar
    ad: DateRange; // gregorian calendar
}



// WEBPACK FOOTER //
// ./src/app/models/date-range.ts